<template>
    <div>
        <div :class="'post__loader ' + active" id="postLoader">
            <img :style="st ? st : ''" src="../assets/loading.png" alt="loader">
        </div>
    </div>
</template>
<script>
export default {
  props: ["active", "st"],
}
</script>
<style scoped>
    .post__loader {
        display: none;
        align-items: center;
        justify-content: center;
        width: 100%;
    }
    .post__loader.active {
        display: flex;
    }
</style>
